/**
 * Formatea un número de bytes a un formato legible (KB, MB, GB).
 * @param {number} bytes - El número de bytes.
 * @param {number} decimals - El número de decimales a mostrar.
 * @returns {string} - La cadena formateada.
 */
export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0 || !bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

/**
 * Formatea un número de segundos a un formato legible (ej. 1m 30s).
 * @param {number} totalSeconds - El número total de segundos.
 * @returns {string} - La cadena formateada o '--' si es infinito.
 */
export const formatTime = (totalSeconds) => {
  if (
    totalSeconds === Infinity ||
    totalSeconds === undefined ||
    totalSeconds === null ||
    isNaN(totalSeconds)
  ) {
    return "--";
  }

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60);

  let result = "";
  if (minutes > 0) {
    result += `${minutes}m `;
  }
  result += `${seconds}s`;

  return result.trim();
};
